import { IClassroomUser } from "../../classrooms";
import { IUser } from "../../users";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFramework, IFrameworkResource } from "../types";

export type IFrameworkQueryParameters = {
    framework?: RelationalValue<IFrameworkResource>;
    learner?: RelationalValue<IClassroomUser | IUser>;
};

export type IFrameworkQueryResult = IFramework;

export const frameworkQuery: IApiQueryFunction<IFrameworkQueryParameters> = ({ framework, learner }) => {
    if (!framework) {
        return;
    }

    return {
        method: "GET",
        url: `/frameworks/${mapRelationalValue(framework)}`,
        headers: learner ? { "x-learner-uuid": mapRelationalValue(learner) } : undefined,
    };
};

export const useFrameworkQuery = createApiQueryHook<IFrameworkQueryParameters, IFrameworkQueryResult>(frameworkQuery);
